import { IContextOrder } from "./../types/order.interface";
import { createContext } from "react";

const OrderScreen = createContext<IContextOrder>({});

export default OrderScreen;
